// Environment-driven endpoints. The socket path differs per environment because the
// production reverse proxy mounts the backend under /api.
const API_ENDPOINT = import.meta.env.VITE_API_ENDPOINT || 'http://localhost:5001'
const SOCKET_ENDPOINT = import.meta.env.VITE_SOCKET_ENDPOINT || API_ENDPOINT
const SOCKET_PATH = import.meta.env.VITE_SOCKET_PATH || '/socket.io'

export const URLS = {
  BASE_URL: `${API_ENDPOINT}/api/v1`,
  SOCKET_URL: SOCKET_ENDPOINT,
  SOCKET_PATH: SOCKET_PATH,
}
